import { render, staticRenderFns } from "./lz.vue?vue&type=template&id=2093407b&scoped=true&"
import script from "./lz.vue?vue&type=script&lang=js&"
export * from "./lz.vue?vue&type=script&lang=js&"
import style0 from "./lz.vue?vue&type=style&index=0&id=2093407b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2093407b",
  null
  
)

export default component.exports